export default "__VITE_PUBLIC_ASSET__849fb83d__"